// removed by extract-text-webpack-plugin
module.exports = {"container":"_3yHU87tCHszdfbpbF35EKN"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Custom/Layout/styles.css
// module id = 3183
// module chunks = 0